import React, { PureComponent, ReactNode } from 'react'
import { ILandingContact } from '../../models'
import { LiteralsService } from '../../services'
import StyledSection from './styles'

interface IProps {
  numberOfQuestions: number
  contact: ILandingContact
  language: string
}

interface IState {
  expandedQuestions: number[]
}

const answerPlaceholder = /(\{website\}|\{phone\}|\{email\})/

export class FrequentlyAskedQuestions extends PureComponent<IProps, IState> {
  public state: IState = { expandedQuestions: [] }

  private get questionNumbers(): number[] {
    return Array.from({ length: this.props.numberOfQuestions }, (unused, index) => index + 1)
  }

  private renderAnswerPart = (part: string, index: number): ReactNode => {
    const { phone, email, website } = this.props.contact

    if (part === '{website}') {
      return <a key={ `website-${ index }` } href={ website } target="_blank" rel="noopener noreferrer">{ website }</a>
    }
    if (part === '{phone}') return <a key={ `phone-${ index }` } href={ `tel:${ phone.replace(/\s/g, '') }` }>{ phone }</a>
    if (part === '{email}') return <a key={ `email-${ index }` } href={ `mailto:${ email }` }>{ email }</a>
    return part
  }

  private renderAnswer(questionNumber: number): ReactNode {
    const answer = LiteralsService.get(`faqAnswer${ questionNumber }`, true)

    return answer.split(answerPlaceholder).map(this.renderAnswerPart)
  }

  private toggleQuestion = (event: React.MouseEvent<HTMLButtonElement>) => {
    const questionNumber = Number(event.currentTarget.value)

    this.setState(previousState => ({
      expandedQuestions: previousState.expandedQuestions.includes(questionNumber)
        ? previousState.expandedQuestions.filter(expanded => expanded !== questionNumber)
        : [ ...previousState.expandedQuestions, questionNumber ]
    }))
  }

  private renderQuestion = (questionNumber: number): ReactNode => {
    const isExpanded = this.state.expandedQuestions.includes(questionNumber)
    const answerId = `faq-answer-${ questionNumber }`

    return (
      <li key={ questionNumber }>
        <h3>
          <button
            type="button"
            aria-expanded={ isExpanded }
            aria-controls={ answerId }
            value={ questionNumber }
            onClick={ this.toggleQuestion }
          >
            <span>{ LiteralsService.get(`faqQuestion${ questionNumber }`, true) }</span>
            <span className="toggle-icon" aria-hidden="true" />
          </button>
        </h3>
        <div id={ answerId } className={ `answer ${ isExpanded ? 'expanded' : '' }` }>
          <div className="answer-content">
            <p>{ this.renderAnswer(questionNumber) }</p>
          </div>
        </div>
      </li>
    )
  }

  public render(): ReactNode {
    return (
      <StyledSection id="frequently-asked-questions" aria-labelledby="faq-title">
        <div className="content">
          <h2 id="faq-title">{ LiteralsService.get('frequentlyAskedQuestions', true) }</h2>
          <ul>{ this.questionNumbers.map(this.renderQuestion) }</ul>
        </div>
      </StyledSection>
    )
  }
}
